import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Dialog } from '../Dialog';

export default function ConfirmationDialog(props) {
  const {
    title,
    titleIcon = true,
    subTitle,
    message,
    renderBody,
    handleClose = () => {},
    handleConfirm = () => {},
    cancelButtonText = 'No, cancel',
    continueButtonText = 'Yes, continue',
    width = 'sm',
    canConfirm = true,
  } = props;

  const [confirmPayload, setConfirmPayload] = useState();

  return (
    <Dialog
      title={title}
      titleIcon={titleIcon ? DeleteIcon : null}
      subTitle={subTitle}
      width={width}
      canSave={canConfirm}
      onCancel={handleClose}
      onSave={(event) => handleConfirm(confirmPayload, event)}
      cancelLabel={cancelButtonText}
      saveLabel={continueButtonText}
    >
      {message}
      {renderBody ? renderBody(setConfirmPayload) : null}
    </Dialog>
  );
}
